import { useEffect, useState } from 'react';
import DashBoardHeader from './DashBoardHeader';
import DashboardBody from './DashBoardBody/DashBoardBody';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { fetchCyclesData, fetchPerformanceData } from './actions/performanceDashboardAction';

const TelePerformanceDashboard = () => {
  const dispatch = useDispatch();
  const agentRefId = useSelector((state: RootState) => state.common?.userData.referenceId) || '';

  const [selectedCycle, setSelectedCycle] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(fetchCyclesData(agentRefId, setSelectedCycle));
  }, [agentRefId]);

  useEffect(() => {
    if (selectedCycle) {
      setLoading(true);
      dispatch(fetchPerformanceData(agentRefId, selectedCycle, () => setLoading(false)));
    }
  }, [selectedCycle, agentRefId]);

  return (
    <div className="bg-[#fff] mx-8 my-3 ">
      <DashBoardHeader cycle={selectedCycle} setCycle={setSelectedCycle} />
      <DashboardBody cycle={selectedCycle} loading={loading} />
    </div>
  );
};

export default TelePerformanceDashboard;
